import { Link } from 'react-router';
import { footerNavGroups } from '@/data/navigation';
import { studioFacts } from '@/data/studio';
import { ArrowUpRight, LinkedIn } from '@/icons';

const LINKEDIN_URL =
  'https://www.linkedin.com/in/vladislava-barkevica-kovaļenko-b9a5a0405?utm_source=share_via&utm_content=profile&utm_medium=member_ios';

export function Footer() {
  return (
    <footer className="bg-bg border-t border-border">
      <div className="mx-auto max-w-[1440px] px-6 md:px-12 lg:px-20 pt-24 pb-10">
        <div className="grid lg:grid-cols-[1.3fr_0.7fr] gap-16 lg:gap-24">
          <div>
            <Link to="/contact" className="group inline-block">
              <span className="eyebrow text-ink-muted">Let's talk</span>
              <h2 className="font-display font-medium mt-4 leading-tight text-3xl md:text-4xl lg:text-5xl tracking-tight break-all">
                business@justsee-ltd<span className="text-accent">.com</span>
              </h2>
              <span className="inline-flex items-center gap-2 mt-5 font-sans group-hover:text-accent transition-colors">
                Write to us <ArrowUpRight className="w-4 h-4" />
              </span>
            </Link>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-8 lg:gap-10">
            {footerNavGroups.map((group) => (
              <div key={group.title} className="flex flex-col gap-4">
                <h3 className="eyebrow">{group.title}</h3>
                <ul className="flex flex-col gap-2">
                  {group.links.map((link) => (
                    <li key={link.href}>
                      <Link to={link.href} className="text-sm hover:text-accent transition-colors">
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-24 pt-8 border-t border-border flex flex-col md:flex-row md:items-center justify-between gap-4">
          <p className="mono-meta text-ink-muted">
            © {new Date().getFullYear()} JUST SEE LTD · Cyprus · Reg. {studioFacts.registrationNumber} · TIN {studioFacts.tin}
          </p>
          <a
            href={LINKEDIN_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
            className="inline-flex items-center justify-center w-10 h-10 rounded-full border border-border text-ink-secondary hover:text-accent hover:border-accent transition-colors"
          >
            <LinkedIn className="w-5 h-5" />
          </a>
        </div>
      </div>
    </footer>
  );
}
